export default {
    USER: {
        LIST: 'user.list',
        NEW: 'user.new',
        EDIT: 'user.edit',
    },
    ACCOUNT: {
        LIST: 'account.list',
        NEW: 'account.new',
        EDIT: 'account.edit',
    },
    COMPANY: {
        LIST: 'company.list',
        NEW: 'company.new',
        EDIT: 'company.edit',
    },
    CUSTOMER: {
        LIST: 'customer.list',
        NEW: 'customer.new',
        EDIT: 'customer.edit',
    },
    PRODUCT: {
        LIST: 'product.list',
        NEW: 'product.new',
        EDIT: 'product.edit',
    },
    MOVEMENT: {
        LIST: 'movement.list',
        NEW: 'movement.new',
        EDIT: 'movement.edit',
    },
    RESERVATION: {
        LIST: 'reservation.list',
        NEW: 'reservation.new',
        EDIT: 'reservation.edit',
    },
    CLOSURE: {
        LIST: 'closure.list',
        EDIT: 'closure.edit',
    },
    DASHBOARD: {
        VIEW: 'dashboard.view'
    },
    PROFIT: {
        VIEW: 'profit.view'
    },
    BALANCE: {
        VIEW: 'balance.view'
    },
    AUTH: {
        LOGOUT: 'auth.logout',
        PROFILE: 'auth.profile',
        CURRENT_COMPANY: 'auth.current-company'
    },
    COMMON: {
        HOME: 'common.home',
        PAGE_NOT_FOUND: 'common.page_not_found'
    },
    INSTALLMENT: {
        LIST: 'installment.list',
    },
    EXPENSE: {
        LIST: 'expense.list',
        NEW: 'expense.new',
        EDIT: 'expense.edit',
    },
}
